import { useETSTicketsQueryParams } from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON } from 'gcs-common/constants/IconConstants';
import { type ChangeEvent, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import styles from './styles.module.scss';

const TicketSearchBar = () => {
  const { etsTicketsfilters, setETSTicketsQueryParams } = useETSTicketsQueryParams();

  const [inputValue, setInputValue] = useState(etsTicketsfilters.search ?? '');

  const [updateSearchInputValueDebounced] = useDebouncedCallback((value: string) => {
    setETSTicketsQueryParams({
      search: value,
    });
  }, 500);

  const onChange = ($event: ChangeEvent<HTMLInputElement>) => {
    const { value } = $event.target;
    setInputValue(value);
    updateSearchInputValueDebounced(value.trim());
  };

  return (
    <div className={styles.searchContainer}>
      <IconComponent Icon={ICON.SEARCH} />
      <input
        className={styles.searchInput}
        onChange={onChange}
        placeholder="Beschreibung, ID und Kommission durchsuchen"
        value={inputValue}
        type="search"
      />
    </div>
  );
};

export default TicketSearchBar;
